import React from 'react'
import styles from './InfoTooltip.module.scss'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { TooltipAnchor, BaseComponent } from 'belle-js'
import { trackAnalyticsEvent } from 'analytics'

class InfoTooltip extends BaseComponent {

  constructor (props) {
    super(props)
    this.state = {}
    this.tooltipRef = React.createRef()

    this.bind('handleToggleTooltip')
  }

  handleToggleTooltip () {
    this.tooltipRef.current.toggleTooltip()
  }

  render () {
    const {
      title,
      className,
      children
    } = this.props

    return (
      <div className={styles.InfoTooltip}>
        <span
          className={styles.unassignedText}
          onClick={() => {
            this.handleToggleTooltip()
            trackAnalyticsEvent('Unassigned Tooltip Clicked')
          }}>
          {title}
        </span>
        <div className={classnames(styles.tooltipWrapper, className)}>
          <TooltipAnchor
            ref={this.tooltipRef}
            contentClassName={styles.contentWidth}
            enableHover={undefined}
            showToggleButton={false} >
            { children }
            <span
              className={styles.closeCta}
              onClick={this.handleToggleTooltip}>
                GOT IT
            </span>
          </TooltipAnchor>
        </div>
      </div>
    )
  }

}

InfoTooltip.defaultProps = {
  title: '',
  className: ''
}

InfoTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
}

export default InfoTooltip



// WEBPACK FOOTER //
// ./src/components/Client/InfoTooltip/InfoTooltip.jsx